






import EmployesHorsLigne from "./EmployesHorsLigne.vue";

export default {
    name: "InterventionDashboard",
    components: {
        EmployesHorsLigne,
    },
};
